
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"M.1 1.55V.42C.1.2.3 0 .54 0h15.01c.23 0 .42.19.42.42v1.13c0 .24-.19.43-.42.43h-15a.42.42 0 01-.43-.43zm.47 13.99h15c.24 0 .43-.2.43-.43v-1.13a.42.42 0 00-.42-.42H.57a.42.42 0 00-.43.42v1.13c0 .24.2.43.43.43z","fill":"#323334"}}),_c('rect',{attrs:{"stroke":"#323334","fill":"#323334","x":"6.5","y":"5.02","width":"3.5","height":"5.49","rx":"1"}}),_c('rect',{attrs:{"stroke":"#323334","x":".5","y":"5.02","width":"3.5","height":"5.49","rx":"1"}}),_c('rect',{attrs:{"stroke":"#323334","x":"12.5","y":"5.02","width":"3.5","height":"5.49","rx":"1"}})])])
          )
        }
      }
    